import { Outlet } from "react-router-dom";
import Header from "../Components/Header";
import SideMenu from "../Components/SideMenu";
import "../styles/table.css";

function Layout() {
  return (
    <>
      <Header />
      <SideMenu />
      <main>
        <Outlet />
      </main>

      <footer></footer>
    </>
  );
}

export default Layout;
